import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import styles from "./CustomOrderSummary.module.css";

const CustomOrderSummary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
  VendorName,
  handleCloseSummary,
  productOrders,
  fetchOrderById,
  setEditIndex
}) => {
  const [total, setTotal] = useState({
    TotalGrossWt: 0,
    TotalStoneWt: 0,
    TotalDiamondWt: 0,
    TotalNetWt: 0,
    TotalQty: 0,
    TotalRate: 0,
    TotalItemAmount: 0,
    TotalPackingWt: 0,
  });

  const handleDelete = (index) => {
    const updatedOrders = productOrders.filter((_, i) => i !== index);
    setValue("productOrders", updatedOrders);
  };

  const handleEdit = (index) => {
    const data = productOrders[index];
    setEditValues(data); // Pass the selected order data to the edit state
    setEdit(true); // Enable edit mode
    setIsSummaryOpen(false); // Close the summary view
    setEditIndex(index);

    // Populate form fields with the selected order data
    setValue("sku", { label: data.Label, value: data.SkuId });
    setValue("category", { label: data.Category, value: data.CategoryId });
    setValue("product", { label: data.Product, value: data.ProductId });
    setValue("design", { label: data.Design, value: data.DesignId });
    setValue("purity", { label: data.Purity, value: data.PurityId });
    setValue("grossWt", data.GrossWt);
    setValue("stoneWt", data.StoneWt);
    setValue("diamondWt", data.DiamondWt);
    setValue("netWt", data.NetWt);
    setValue("size", data.Size);
    setValue("length", data.Length);
    setValue("quantity", data.Quantity);
    setValue("ratePerGram", data.RatePerGram);
    setValue("makingPerGram", data.MakingPerGram);
    setValue("fixedMaking", data.FixedMaking);
    setValue("fixedWt", data.FixedWt);
    setValue("makingPercentage", data.MakingPercentage);
    setValue("diamondPieces", data.DiamondPieces);
    setValue("diamondAmount", data.DiamondAmount);
    setValue("stoneAmount", data.StoneAmount);
    setValue("screwType", { label: data.ScrewType, value: data.ScrewTypeId });
    setValue("polish", data.Polish);
    setValue("rhodium", { label: data.Rhodium, value: data.RhodiumId });
    setValue("sampleWt", data.SampleWt);
    setValue("remarks", data.Remarks);
  };

  const handleApplyEdit = (updatedOrder, index) => {
    const updatedOrders = [...productOrders];
    updatedOrders[index] = updatedOrder; // Update the specific order with new values
    setValue("productOrders", updatedOrders); // Update the state with the modified orders
    setEdit(false); // Exit edit mode
    setIsSummaryOpen(true); // Reopen the summary view
  };

  useEffect(() => {
    let grossWt = 0;
    let stoneWt = 0;
    let diamondWt = 0;
    let netWt = 0;
    let qty = 0;
    let rate = 0;
    let itemAmt = 0;
    let packingWt = 0;

    productOrders.forEach((order) => {
      grossWt += parseFloat(order.GrossWt || 0);
      stoneWt += parseFloat(order.StoneWt || 0);
      diamondWt += parseFloat(order.DiamondWt || 0);
      netWt += parseFloat(order.NetWt || 0);
      qty += parseInt(order.Quantity || 0);
      rate += parseFloat(order.RatePerGram || 0);
      itemAmt += parseFloat(order.TotalItemAmount || 0);
      packingWt += parseFloat(order.PackingWeight || 0);
    });

    setTotal({
      TotalGrossWt: grossWt,
      TotalStoneWt: stoneWt,
      TotalDiamondWt: diamondWt,
      TotalNetWt: netWt,
      TotalQty: qty,
      TotalRate: rate,
      TotalItemAmount: itemAmt,
      TotalPackingWt: packingWt,
    });
  }, [productOrders]);

  return (
    <div className={styles.summaryContainer}>
      <div className={styles.tableContainer}>
        <table className={styles.summaryTable}>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Item Details</th>
              <th>Order ID</th>
              <th>Gross Wt</th>
              <th>Stone Wt</th>
              <th>Dia Wt</th>
              <th>Net Wt</th>
              <th>Size</th>
              <th>Qty</th>
              <th>Rate</th>
              <th>Total Item Amt</th>
              <th>URD Amt</th>
            </tr>
          </thead>
          <tbody>
            {productOrders.map((order, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td>
                  <div className={styles.itemDetailsContainer}>
                    <span>
                      {order.Category} - {order.Product} - {order.Design} -{" "}
                      {order.Purity}
                    </span>
                    <div
                      className={styles.actionIcons}
                      style={{
                        display: "inline-flex",
                        // gap: "10px",
                        marginLeft: "10px",
                      }}
                    >
                      <Icon
                        title="Edit"
                        icon="material-symbols-light:edit-outline"
                        width="15"
                        height="15"
                        style={{ color: "#627282", cursor: "pointer" }}
                        onClick={() => handleEdit(index)} // Ensure the correct index is passed
                      />
                      <Icon
                        title="Delete"
                        icon="weui:delete-outlined"
                        width="15"
                        height="15"
                        style={{ color: "#627282", cursor: "pointer" }}
                        onClick={() => handleDelete(index)}
                      />
                      <Icon
                        title="Apply"
                        icon="material-symbols-check-circle-outline"
                        width="15"
                        height="15"
                        style={{ color: "#0077d4", cursor: "pointer" }}
                        onClick={() => handleApplyEdit(order, index)} // Apply the updated order
                      />
                    </div>
                  </div>
                </td>
                <td style={{ textAlign: "center" }}>
                  {order.OrderId || "N/A"}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.GrossWt || 0).toFixed(3)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.StoneWt || 0).toFixed(3)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.DiamondWt || 0).toFixed(3)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.NetWt || 0).toFixed(3)}
                </td>
                <td style={{ textAlign: "center" }}>{order.Size}</td>
                <td style={{ textAlign: "center" }}>{order.Quantity}</td>
                <td style={{ textAlign: "center" }}>
                  {(+order.RatePerGram || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.TotalItemAmount || 0).toFixed(2)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {(+order.URDAmt || 0).toFixed(2)}
                </td>
              </tr>
            ))}
            <tr>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <select
                    style={{
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      boxSizing: "border-box",
                      height: "25px",
                      width: "150px",
                      zIndex: 10,
                    }}
                  >
                    <option value="">Select Item</option>
                    {/* Add options dynamically if needed */}
                  </select>
                  <Icon
                    icon="weui:add-outlined"
                    width="20"
                    height="20"
                    style={{ color: "#0077d4", cursor: "pointer" }}
                    onClick={() => {
                      setEdit(false);
                      setIsSummaryOpen(false);
                    }}
                  />
                </div>
              </td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}></td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}>Total</td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}>
                {total.TotalGrossWt.toFixed(3)}
              </td>
              <td style={{ textAlign: "center" }}>
                {total.TotalStoneWt.toFixed(3)}
              </td>
              <td style={{ textAlign: "center" }}>
                {total.TotalDiamondWt.toFixed(3)}
              </td>
              <td style={{ textAlign: "center" }}>
                {total.TotalNetWt.toFixed(3)}
              </td>
              <td style={{ textAlign: "center" }}></td>
              <td style={{ textAlign: "center" }}>{total.TotalQty}</td>
              <td style={{ textAlign: "center" }}>
                {total.TotalRate.toFixed(2)}
              </td>
              <td style={{ textAlign: "center" }}>
                {total.TotalItemAmount.toFixed(2)}
              </td>
              <td style={{ textAlign: "center" }}>
                {total.TotalPackingWt.toFixed(3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomOrderSummary;
